import { Autocomplete, Box, Table, Textarea } from '@mui/joy';
import { FormControl, FormLabel } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { post, Token } from '../../../Script/Session';

function HistoryTable() {
  const location = useLocation();
  const { showtable  } = location.state || {};
  const [data, setdata] = useState(showtable);
  const navigate = useNavigate();

  return (
    <Table sx={{ minHeight: "100vh", background: "white" }}>
      <thead>
        <th>Frage</th>
        <th>Neu</th>
        <th>Alt</th>
      </thead>
      <tbody>
        {Array.isArray(data?.questions?.fragen) &&
          data.questions.fragen
            .slice()
            .sort((a, b) => a.order - b.order)
            .map((item, index) => {
              const keys = Object.keys(item).filter(k => k !== "order");
              const name = keys[0] || "Unbenannt";

              return (
                <React.Fragment key={`${index}-${name}`}>
                  <tr>
                    <td colSpan={3} style={{ fontWeight: 'bold' }}>{name}</td>
                  </tr>

                  {Array.isArray(item[name]) &&
                    item[name]
                      .slice()
                      .sort((a, b) => a.order - b.order)
                      .map((frage, idx) => {
                        const fieldName = frage.name;
                        const newValue = data?.new?.[fieldName] || "";
                        const oldValue = data?.old?.[fieldName] || "";

                        const newBewertungId = data?.logbnew?.[fieldName];
                        const oldBewertungId = data?.logbold?.[fieldName];

                        const textColor = newValue !== oldValue ? "yellow" : "white";
                        const ratingColor = newBewertungId !== oldBewertungId ? "yellow" : "white";

                        return (
                          <tr key={`${index}-${idx}`}>
                            <td>{fieldName}</td>

                            {/* New Value */}
                            <td>
                              <Box sx={{ display: "flex", flexDirection: "column" }}>
                                <FormControl>
                                  <FormLabel />
                                  <Textarea
                                    sx={{ bgcolor: textColor }}
                                    minRows={4}
                                    maxRows={4}
                                    value={newValue}
                                    variant="outlined"
                                    readOnly
                                  />
                                </FormControl>
                                <Autocomplete
                                  options={frage.bewertung}
                                  getOptionLabel={(i) => i.bzh}
                                  value={
                                    frage.bewertung.find(i => i.id === newBewertungId) || null
                                  }
                                  readOnly
                                  sx={{ mt: 1, bgcolor: ratingColor }}
                                />
                              </Box>
                            </td>

                            {/* Old Value */}
                            <td>
                              <Box sx={{ display: "flex", flexDirection: "column" }}>
                                <FormControl>
                                  <FormLabel />
                                  <Textarea
                                    sx={{ bgcolor: textColor }}
                                    minRows={4}
                                    maxRows={4}
                                    value={oldValue}
                                    variant="outlined"
                                    readOnly
                                  />
                                </FormControl>
                                <Autocomplete
                                  options={frage.bewertung}
                                  getOptionLabel={(i) => i.bzh}
                                  value={
                                    frage.bewertung.find(i => i.id === oldBewertungId) || null
                                  }
                                  readOnly
                                  sx={{ mt: 1, bgcolor: ratingColor }}
                                />
                              </Box>
                            </td>
                          </tr>
                        );
                      })}
                </React.Fragment>
              );
            })}






      </tbody>
    </Table>
  )
}

export default HistoryTable
